import { get } from 'lodash';

const getGoogleTagManagerDataLayerName = (rootState) =>
  get(rootState, 'config.service.common.google-tag-manager.dataLayerName', '');

export default getGoogleTagManagerDataLayerName;
